import { render, staticRenderFns } from "./DomainTldForm.vue?vue&type=template&id=05098074&"
import script from "./DomainTldForm.vue?vue&type=script&lang=js&"
export * from "./DomainTldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports